'use client';

import { Clock, CheckCircle } from 'lucide-react';

export default function OddsRefreshBanner() {
  const lastFetched = 'Today at 6:00 AM EST';
  const nextScheduled = 'Tomorrow at 6:00 AM EST';

  return (
    <div className="mb-6 flex items-center gap-3 p-4 rounded-xl border border-[hsl(var(--primary)/0.2)] bg-[hsl(var(--primary)/0.04)]">
      <div className="w-8 h-8 rounded-lg bg-[hsl(var(--primary)/0.1)] border border-[hsl(var(--primary)/0.2)] flex items-center justify-center flex-shrink-0">
        <CheckCircle size={15} className="text-[hsl(var(--primary))]" />
      </div>
      <div className="flex flex-col gap-0.5">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-[hsl(var(--foreground))]">Odds are current</span>
        </div>
        <div className="flex items-center gap-4 text-xs text-[hsl(var(--foreground-muted))]">
          <span className="flex items-center gap-1">
            <Clock size={11} />
            Last fetched: {lastFetched}
          </span>
          <span className="hidden sm:flex items-center gap-1">
            <Clock size={11} />
            Next auto-refresh: {nextScheduled}
          </span>
        </div>
      </div>
    </div>
  );
}